import React from "react";
import PropTypes from "prop-types";
import { Row, Col } from "reactstrap";
import NeoModal from "../../../../components/Common/NeoModal";
import NeoInput from "../../../../components/Common/NeoInput";
import NeoButton from "../../../../components/Common/NeoButton";

const ConfirmPaymentModal = ({
    isOpen,
    toggle,
    selectedFatura,
    formConfirm,
    onChangeField,
    onConfirm
}) => {
    const modalFooter = (
        <>
            <NeoButton variant="secondary" onClick={toggle}>
                Cancelar
            </NeoButton>
            <NeoButton variant="success" onClick={onConfirm}>
                Confirmar Pagamento
            </NeoButton>
        </>
    );

    return (
        <NeoModal
            isOpen={isOpen}
            toggle={toggle}
            title="Registrar Recebimento Manual"
            footerActions={modalFooter}
        >
            {selectedFatura && (
                <div>
                    <p className="text-muted text-sm mb-3">
                        Cliente: <strong className="text-dark">{selectedFatura.schoolName}</strong> | Fatura: <strong className="text-dark">{selectedFatura.id}</strong>
                    </p>
                    <p>
                        Valor a Receber: <strong className="text-success fs-5">R$ {selectedFatura.amount.toLocaleString("pt-BR", { minimumFractionDigits: 2 })}</strong>
                    </p>
                    <Row className="g-3 mt-1">
                        <Col md={6}>
                            <NeoInput
                                label="Meio de Liquidação"
                                type="select"
                                value={formConfirm.method}
                                onChange={(e) => onChangeField("method", e.target.value)}
                                options={[
                                    { value: "Pix", label: "Pix" },
                                    { value: "Boleto", label: "Boleto Bancário" },
                                    { value: "Dinheiro", label: "Dinheiro / Depósito" },
                                    { value: "Cortesia", label: "Permuta / Cortesia" }
                                ]}
                            />
                        </Col>
                        <Col md={6}>
                            <NeoInput
                                label="Data de Recebimento"
                                type="date"
                                value={formConfirm.paidDate}
                                onChange={(e) => onChangeField("paidDate", e.target.value)}
                            />
                        </Col>
                    </Row>
                </div>
            )}
        </NeoModal>
    );
};

ConfirmPaymentModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    toggle: PropTypes.func.isRequired,
    selectedFatura: PropTypes.object,
    formConfirm: PropTypes.object.isRequired,
    onChangeField: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired
};

export default ConfirmPaymentModal;
